import { createContext } from 'react';

export const BulkEntryContext = createContext();
